const BAND = "M116.8 16.1a88 88 0 1 1-45.6 3.3";

/**
 * The open ring behind Orla: a deep blue band lit from within, a hairline of light along
 * its edge, and three fine arcs glowing inside it. Decorative, so it is hidden from
 * assistive technology.
 */
export function RingBackdrop() {
  return (
    <svg className="ring-backdrop" viewBox="0 0 200 200" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient
          id="ring-band"
          x1="30"
          y1="0"
          x2="170"
          y2="200"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#0a5ba6" />
          <stop offset="0.52" stopColor="#084474" />
          <stop offset="1" stopColor="#042140" />
        </linearGradient>
        <linearGradient
          id="ring-rim"
          x1="20"
          y1="10"
          x2="180"
          y2="190"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#9fdcff" stopOpacity="0.85" />
          <stop offset="0.35" stopColor="#2aa8f5" stopOpacity="0.45" />
          <stop offset="0.7" stopColor="#1e88d8" stopOpacity="0.12" />
          <stop offset="1" stopColor="#7fd0ff" stopOpacity="0.5" />
        </linearGradient>
        <filter id="ring-bloom" x="-30%" y="-30%" width="160%" height="160%">
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <circle className="ring-backdrop__aura" cx="100" cy="100" r="98" />
      <path d={BAND} fill="none" stroke="url(#ring-rim)" strokeWidth="29" strokeLinecap="round" />
      <path
        d={BAND}
        fill="none"
        stroke="url(#ring-band)"
        strokeWidth="27.6"
        strokeLinecap="round"
      />
      {/* The three fine arcs inside it, drawn in as she arrives. */}
      <g className="ring-backdrop__fine" filter="url(#ring-bloom)">
        <circle cx="100" cy="100" r="46" fill="none" pathLength="100" />
        <circle cx="100" cy="100" r="38" fill="none" pathLength="100" />
        <circle cx="100" cy="100" r="30" fill="none" pathLength="100" />
      </g>
    </svg>
  );
}
